module.exports = __webpack_public_path__ + "7e4b29ba/img/saly-icon.39e12342.jpg";